<template>
<div>
<v-expansion-panels
    v-if="parse != null"
    class="panels"
>
    <v-expansion-panel>
        <v-expansion-panel-header>
            Style: {{label}}
        </v-expansion-panel-header>
        <v-expansion-panel-content>

            <m-edit-css-property
                v-for="(item, index) in parse.properties"
                :key="'_prop_'+index"
                :label="item.name"
                :value="item"
                v-on:modify="onModify"
            />

            <div
                style="text-align: right"
            >
                <v-btn  
                    fab
                    dark
                    color="primary"
                    style="margin-right: 15px"
                    v-on:click="onClickReset"
                >
                    <v-icon>
                        mdi-restore
                    </v-icon>
                </v-btn>

                <v-btn  
                    fab
                    dark
                    color="primary"
                    v-on:click="onClickAppend"
                >
                    <v-icon>
                        mdi-plus
                    </v-icon>
                </v-btn>
            </div>

        </v-expansion-panel-content>
    </v-expansion-panel>
    
</v-expansion-panels>

</div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: function() { return 'Label'; }
        },
        value: {
            type: String,
            default: function() { return ''; }
        },
        default_value: {
            type: String,
            default: function() { return ''; }
        }
    },
    
    data() {
        return {
            parse: null,
        }
    },

    created () {
        this.parseValue();
    },

    methods: {
        parseValue() 
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/css/inline/parse',
            
                'params' : {
                        'inline_style': this.value,
                        'default_inline_style': this.default_value,
                    },
            
                'on_success': (data) => {
                        this.parse = data;
                    },
            
                'on_error': 'Unable to parse style',
            });    
        },

        onModify(operation)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/css/inline/modify',
            
                'params' : {
                    'inline_style': this.value,
                    'default_inline_style': this.default_value,
                    ...operation,
                },
            
                'on_success': (data) => {
                        this.parse = data;
                        this.$emit('input', data.inline_style);
                    },
            
                'on_error': 'Unable to modify styling',
            });
        },

        onClickReset()
        {
            this.$rc.confirm({
                'title': 'Reset Styling: '+this.label,
                'body': 'Do you want to reset the styling to the default?<br/><br/>This can not be undone.',
                'btn_text_ok': 'Reset',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doReset();
                },
            });
        },

        doReset()
        {
            this.value = this.default_value;
            this.$emit('input', this.value);
        },

        onClickAppend()
        {
            this.$rc.prompt({
                'title': 'Add CSS',
                'label': 'CSS to append',
                'value': '',
                'unset_label': null,
            
                'after_prompt': (value) => {
                    this.onModify({
                        'op': 'append',
                        'value': value
                    });
                },
            });
        }
    },

    watch: {
        value(newValue, oldValue) {
            this.parseValue(); 
        }
    },
}
</script>

<style lang="scss" scoped>
.panels
{
    margin-bottom: 15px; 
    border-left: 1px solid rgba(0,0,0,0.1); 
    border-top: 1px solid rgba(0,0,0,0.1);
}
</style>